module.exports = __webpack_public_path__ + "img/avatar.f63c8ebc.jpg";